import { adModal, solAdsIFrame, trafficStarsGallerySlide } from "@modules/single-page/gallery/templates"
import {
    injectTrafficStarsScript,
    trafficStarsGalleryClosingExplicitSpot,
    trafficStarsGalleryClosingTemplateId,
} from "@modules/traffic-stars/templates"
import type Swiper from "swiper"
import type { SwiperContainer, SwiperSlide } from "swiper/element"
import "./plutos.css"

export function initializeGalleryAds(swiperContainer: SwiperContainer, swiper: Swiper): void {
    if (userData.isLoggedIn && userData.hasAdFree) {
        return
    }

    if (SiteInfo.isMobileVersion) {
        addClosingAdListener(swiperContainer)
        return
    }

    addAdSlides(swiper)
    updateGalleryThumbnailSlideIndices()
}

export function initializeThumbnailAds(swiper: Swiper): void {
    if (userData.isLoggedIn && userData.hasAdFree) {
        return
    }

    if (SiteInfo.isMobileVersion) {
        return
    }

    addHiddenThumbnailSlidesToFixSlideHighlighting(swiper)
}

function addClosingAdListener(swiperContainer: SwiperContainer): void {
    $(swiperContainer)
        .closest(".modal")
        .on("hide.bs.modal", (): void => {
            injectClosingGalleryAd()
        })
}

const injectionIndex: number = 2

function addAdSlides(swiper: Swiper): void {
    const swiperContainer = swiper.el as HTMLElement
    swiperContainer.dataset.originalSlideCount = String(swiper.slides.length)

    if (swiper.slides.length > 2) {
        const slide1: SwiperSlide = createAdSlide()
        swiper.addSlide(injectionIndex, slide1)
        injectGalleryTrafficStarsScript(slide1)
    }

    const slide2 = createAdSlide()
    swiper.addSlide(swiper.slides.length, slide2)
    injectGalleryTrafficStarsScript(slide2)

    swiper.update()
}

function createAdSlide(): SwiperSlide {
    const slideElement = document.createElement("swiper-slide") as SwiperSlide

    const template = userData.isAgeVerified ? trafficStarsGallerySlide : solAdsIFrame
    const contentElement = template?.cloneNode(true) as HTMLElement | null
    if (contentElement) {
        contentElement.dataset.galleryText = "Anzeige"
        slideElement.appendChild(contentElement)
    }

    return slideElement
}

function injectGalleryTrafficStarsScript(slide: SwiperSlide): void {
    if (!userData.isAgeVerified) return
    const container = slide.querySelector(".uncensored-banner-container")
    if (container) {
        injectTrafficStarsScript(
            container,
            trafficStarsGalleryClosingExplicitSpot,
            trafficStarsGalleryClosingTemplateId,
        )
    }
}

function updateGalleryThumbnailSlideIndices(): void {
    const indexThumbnails: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>(".gallery_item[data-index]")

    for (const thumbnail of indexThumbnails) {
        const index: number = Number.parseInt(thumbnail.dataset.index || "", 10) || 0

        if (index >= injectionIndex) {
            thumbnail.dataset.index = (index + 1).toString()
        }
    }
}

function addHiddenThumbnailSlidesToFixSlideHighlighting(swiper: Swiper): void {
    const slide1: SwiperSlide = document.createElement("swiper-slide") as SwiperSlide
    slide1.style.visibility = "hidden"
    slide1.style.width = "0"

    const slide2: SwiperSlide = document.createElement("swiper-slide") as SwiperSlide
    slide2.style.visibility = "hidden"
    slide2.style.width = "0"

    swiper.addSlide(injectionIndex, slide1)
    swiper.addSlide(swiper.slides.length, slide2)

    swiper.update()
}

function injectClosingGalleryAd(): void {
    const galleryInject = adModal?.cloneNode(true) as HTMLElement

    if (galleryInject !== null) {
        document.querySelector(".vp")?.appendChild(galleryInject)

        const adContainer = galleryInject.querySelector("#galleryInjectAdContainer")
        if (adContainer) {
            if (userData.isAgeVerified) {
                const label = document.createElement("p")
                label.className = "gi-text"
                label.textContent = "Anzeige"
                adContainer.appendChild(label)
                injectTrafficStarsScript(
                    adContainer,
                    trafficStarsGalleryClosingExplicitSpot,
                    trafficStarsGalleryClosingTemplateId,
                )
            } else {
                const solAd = solAdsIFrame?.cloneNode(true) as HTMLElement
                if (solAd) {
                    const iframe = solAd.querySelector("iframe")
                    if (iframe) {
                        iframe.width = "300"
                        iframe.height = "250"
                        iframe.style.width = "300px"
                        iframe.style.height = "250px"
                    }
                    adContainer.appendChild(solAd)
                }
            }
        }
    }
}
